import React, { useState } from 'react';
import { Alert, Icon, IconButton, Loader } from 'rsuite';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import usePrefix from '@/hooks/usePrefix';
import { Button, ConfirmModal } from '@/components/Bicester';
import useMbrCeremonyList from '@/hooks/preload/useMbrCeremonyList';
import Image from '@/components/Bicester/Image';
import { useRequest } from 'ahooks';
import { fetchSendMembershipCeremony } from '@/services/account';
import PageLoader from '@/components/shared/PageLoader';

interface MbrCeremonyModalProps {
  /** 用户id */
  userId: number;
  onReGetInfo: () => void;
}

export default NiceModal.create(({ userId, onReGetInfo }: MbrCeremonyModalProps) => {
  const modal = useModal();
  const confirmModal = useModal(ConfirmModal);
  const { prefix, classname } = usePrefix('bicester-modal');
  const [selected, setSelected] = useState(null);
  const { data: listData, loading: listLoading } = useMbrCeremonyList();

  const { run: send, loading: sendLoading } = useRequest(fetchSendMembershipCeremony, {
    manual: true,
  });

  const handleConfirm = (tips: string, type: 1 | 2) => {
    if (selected?.id) {
      confirmModal.show({
        contentText: tips,
        submitText: '确认',
        cancelText: '取消',
        onSubmit: () => {
          send({
            id: userId,
            coupons_id: selected.id,
            type, // 1放入卡包暂不兑换 2兑换
          }).then((res) => {
            if (res.status === '200000') {
              Alert.success(type === 1 ? '已放入卡包' : '兑换成功');
              modal.hide();
              onReGetInfo?.();
            }
          });
        },
      });
    } else {
      Alert.error('请选择一个入会礼');
    }
  };

  return (
    <>
      <div className={classname}>
        {sendLoading && <PageLoader style={{ zIndex: 9999 }} />}
        {modal.visible && (
          <div className="w-full h-screen fixed top-0 left-0 bg-black bg-opacity-40 flex justify-center items-center z-[999]">
            <div className="relative flex flex-col items-center p-[40px] bg-[#fff]">
              <div className="mb-[10px]">请选择入会礼（二选一）</div>
              <IconButton
                icon={<Icon icon="close" />}
                appearance="subtle"
                style={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  width: 36,
                  fontSize: 24,
                }}
                onClick={modal.hide}
              />

              <div className="w-full h-[200px] flex justify-around items-center">
                {listLoading ? (
                  <Loader vertical />
                ) : (
                  listData?.map((item, index) => (
                    <div
                      className={`cursor-pointer p-[10px] border-2 border-solid ${
                        selected?.id === item.id ? 'border-[#455255]' : 'border-[#cccccc]'
                      } ${index === listData?.length - 1 ? '' : ' mr-[20px]'}`}
                      onClick={() => setSelected(item)}
                    >
                      <Image src={item.img_url} className="w-[200px] h-[150px] object-contain" />
                      <div className="text-center">{item.name}</div>
                    </div>
                  ))
                )}
              </div>
              <div className="flex justify-between h-[33px] mt-[20px]">
                <Button
                  className={`${prefix('btn')} mr-[35px] tracking-normal`}
                  onClick={() =>
                    handleConfirm(`您选择了${selected?.name}，并且放入卡包，暂不兑换`, 1)
                  }
                >
                  放入卡包，暂不兑换
                </Button>
                <Button
                  className={prefix('btn')}
                  onClick={() => handleConfirm(`您选择了${selected?.name}，并且立即兑换`, 2)}
                >
                  立即兑换
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
});
